
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqQItELHEJpsSxwq2oBoe6vbDcwXp4UjBszH8qQbTtFPkMeta } from "/codebuild/output/src3865272267/src/src/pages/faq.vue?macro=true";
import { default as menuFfU6j7nhJkxeBdE5g4v2IseqrV9Yg82bcqs8QcE7hsQMeta } from "/codebuild/output/src3865272267/src/src/pages/menu.vue?macro=true";
import { default as indexb8OWvbC8sEYyWAwFWlyaEyanwNJeBQDEzx_45ykfG6R7AMeta } from "/codebuild/output/src3865272267/src/src/pages/index.vue?macro=true";
import { default as contactN3T6WBwOL7g_EeklnDgPsP64ef6fL8Qi_45wDak_zJQFcMeta } from "/codebuild/output/src3865272267/src/src/pages/contact.vue?macro=true";
import { default as tutorialnAgYWS0fCvEvH0W81i8m0m8bI9D3eDs1uoa54h0Z6AUMeta } from "/codebuild/output/src3865272267/src/src/pages/tutorial.vue?macro=true";
import { default as agreementGktIkTiTbKXrAy_45_45eJF9_45pIyE0YrpsyzomyE5codckgMeta } from "/codebuild/output/src3865272267/src/src/pages/agreement.vue?macro=true";
import { default as about_45passk58mmrFTiHQ_HBS556Ll4ZpS2_BfbS7VBY_45TbIBKl4oMeta } from "/codebuild/output/src3865272267/src/src/pages/about-pass.vue?macro=true";
import { default as indexoibe6HGNasCCnbomrfDDm__0tg8IemuDIV4q_CoZsAQMeta } from "/codebuild/output/src3865272267/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93FzuwA1uFdwgcZOMbHFYr6U4hwZ8YYWW06LZWUeCtMAAMeta } from "/codebuild/output/src3865272267/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceAaacCryKvUNIiQQAmvYU7TsaboflKEElv5trpkRp1kYMeta } from "/codebuild/output/src3865272267/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93RvQm599WBcUSfZJwTMAxUGUygva7JWqKlYOclcQbhgwMeta } from "/codebuild/output/src3865272267/src/src/pages/notice/[id].vue?macro=true";
import { default as index8rq5MB6Hmv55dn3fRe2swbRYqP_05yqLmtRYG6NOcWMMeta } from "/codebuild/output/src3865272267/src/src/pages/coupon/index.vue?macro=true";
import { default as indexWV53Qm9wFjcEQVdIR8hMcuU5OxkFF2Lo1pI15iVSJmsMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/index.vue?macro=true";
import { default as indexMnlehojAlFv5oZxHCbMWfanZHCapW2i_rm_zokYrdMkMeta } from "/codebuild/output/src3865272267/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93CYeMZI6mI_Uq0Q2iC4SmnZaga7fASqjbbiMcP3_5lEoMeta } from "/codebuild/output/src3865272267/src/src/pages/parking/[id].vue?macro=true";
import { default as index9z0__WRBBLuSa02cNGqEaG6anNyupVHFrAe86R77WtgMeta } from "/codebuild/output/src3865272267/src/src/pages/history/index.vue?macro=true";
import { default as indexLKwr7PSvAfOUKZR_453yLmZMuZYlAr4GhQGVJq90BQmhsMeta } from "/codebuild/output/src3865272267/src/src/pages/monthly/index.vue?macro=true";
import { default as indexTagOr1VbE9g7QFZK9nF85qULahG910RvFhsmsS2lcCsMeta } from "/codebuild/output/src3865272267/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexZXj3QVbVFocbU28kaIG2MUJb5Ru6UojiGMAvkxjqkXMMeta } from "/codebuild/output/src3865272267/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavii_45i1kDB2wBJ4FbnpqZmQtKNJUM2tNH7T7FexvzZurBkMeta } from "/codebuild/output/src3865272267/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editFWe4_4578RdhmuJmE4iLiC57tW6KaLSmjmNELNLSsfli0Meta } from "/codebuild/output/src3865272267/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement12_6xh5gIwVvQwKb39cOZPgCniWua_45hhiipGTw9ZYpQMeta } from "/codebuild/output/src3865272267/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexizFzxTZUy1I_45Hbvy8SqsS_45yUd8ByO8Snj4Ivc2ZCvt8Meta } from "/codebuild/output/src3865272267/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dRPjAngAPZkgKUxVaqt2QFuulbBs1YQAev0zUar82WcMMeta } from "/codebuild/output/src3865272267/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm_M36jpINOfAJYB51PfqMxwjhbMKk_45gfwTau_45dv_u7GEMeta } from "/codebuild/output/src3865272267/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexTXaB5GkFClYV_ZNoc_45_450qATSpJsdR4MO7NdqOFbm_45b8Meta } from "/codebuild/output/src3865272267/src/src/pages/card/create/index.vue?macro=true";
import { default as index2BOgKugjkw21EwiapVNtuQ1_qN4_NwqKC9cdfUXfsj4Meta } from "/codebuild/output/src3865272267/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmlt0eTz_m6gz4aIOoW_tx0qP5pmNfnsNIBjtqWYsXh9AMeta } from "/codebuild/output/src3865272267/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmG5meFqNJJBXse9d_458_1cPrrkAh7FLmSc4X34eTsjh_45MMeta } from "/codebuild/output/src3865272267/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeq8us3chmiEeO_452KMUuUuLLsmAYGv2hmsxO_1OYUbV_45AMeta } from "/codebuild/output/src3865272267/src/src/pages/membership/complete.vue?macro=true";
import { default as registereT_45tO2y5BrqasZiKskRYeIZCGFRJgygeLTAJOk7KTyMMeta } from "/codebuild/output/src3865272267/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93zLPVLmUqQQSDL5fEfFLltijAA4mNXPFXiuWs3e3hvB4Meta } from "/codebuild/output/src3865272267/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmYqHfBQWTnKwil6xJuW51ep_451CSFhhVuTZYDl615FtXwMeta } from "/codebuild/output/src3865272267/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93bBqDZYsEYocDP0nBhbL6PsXWXCETDt9o6wVG6baz_45S8Meta } from "/codebuild/output/src3865272267/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexZTMYKMkkcjzndbBWggzP7BWEz_gr_45SBof6pIyZW71Z0Meta } from "/codebuild/output/src3865272267/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codecYwvJ3DoxxU_45oFYpYDKzNLlakOJZNISWIa4B6PHhytMMeta } from "/codebuild/output/src3865272267/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code265RxsrJmWCWDI8Xcwnun29tISxSncaw0V_7A67FOCEMeta } from "/codebuild/output/src3865272267/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeBdtWR1DOZ4hrBUPUpdqVVcKp2JqDUrUllLq0mafcDQkMeta } from "/codebuild/output/src3865272267/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerdQod6tOReV_4562Efk4_KkERO5N8VOh188QHZD09_OxtkMeta } from "/codebuild/output/src3865272267/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeymiqJWiEhzSeJQiOOVslG6DufRcwWZS657QPpICT6gEMeta } from "/codebuild/output/src3865272267/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexAoy8kRyRYT_45rU8ePHWLbg6B7wUNie3BsgwBoH_mEJoIMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmnfZDKWSsEtx0XMJwOLn_45nlo05J2F6KF_451NvGVwt_X5YMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeccBUQ24xsv6XGvoJ8_lfV0TqrC0uIQ7hjH162zqHxzsMeta } from "/codebuild/output/src3865272267/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexZ4NQT0ny2x90inrtF39_mfk00Bzk6Q7POl5_45GPgsM64Meta } from "/codebuild/output/src3865272267/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93dnswJzth7B7I2mSdydesqwp0sjP4g_45SdWjXoH5GRvAMMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete_45bAlMHKPgfi4K7M8ECS2ek0zjK_hlEeR_45FPtpZd1OacMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasSfG6Zz5CqarCZYsX7tj6aWacd9veqsWzX_LPf98rmIgMeta } from "/codebuild/output/src3865272267/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample_45EOS2qjsATWUzM7Ey4r5QYrEUdnUoQwUNIIVF9pvdtUMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email7h0rPBa207UZIfhgAfREwUiCaieyOtzb99WeVZbRQA0Meta } from "/codebuild/output/src3865272267/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmQH849Us_45FgdtmPdYwyFh4tzQe8gTeUyMVdooUYlcUooMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentjGPPFFFOkul7C21gr942lyd57SW66G_0Pyu8_45JT14hMMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmINXsEELaKxAgXGceyZmnIxMWUtK4k4wPnyO0HwZGUEEMeta } from "/codebuild/output/src3865272267/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatebbtpfL6EVd5l3d4ozKp230KVc6M0W_eRPvthFeSFqnUMeta } from "/codebuild/output/src3865272267/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeyqsVY7Wj06XVo4AuPAZduH5I6Pv4fSGUhj5LaAJ5ZlsMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code4RAVbeHz_FdcPcwFBYcvU8EH1SGOou38XTOQ2BdSHc0Meta } from "/codebuild/output/src3865272267/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordnRmmBcPAmz8Oyqx37diGSUwvxs7WhFECq_45HMQ3hH1NEMeta } from "/codebuild/output/src3865272267/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasLHZZATqcxqe1c_45IW7ITLYYQSv8_45Js0eYStc_457Y1WrgEMeta } from "/codebuild/output/src3865272267/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register4mtTOtiTYsVtAMMietatPQSqFlY6PWt_TlrozfDem4QMeta } from "/codebuild/output/src3865272267/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeBv7ikFRlOtYRB811aZlQASHVAK2r5MeZ6Lvq5rK9TZwMeta } from "/codebuild/output/src3865272267/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexR1XK4Gph00ugRYPAc1oCxP_8IdGt2OSK36o8_45R3rIAQMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexdeIWK7N0zOoCCxudfmtuBuIx5zTmR9XJOFWlaaw4tJ8Meta } from "/codebuild/output/src3865272267/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexgSjchXRIZuoAgvK_neJPTnLtmWoZTm72dP490wxa9iYMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexvzf0TI07oqrbd7iQ9rELiHjOBQqwZ6jTJdiXiBXtsqcMeta } from "/codebuild/output/src3865272267/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatekeHvpDLnIRx6VX0xYUuzXStgylIgnWu6sq_neTIkpA4Meta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete94i2cii1zyO5ho2lCPyU1uiL99nWv2SiziK1vldqMaUMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmccj7_V3yciY5B06ZmdSacM0yoE_RldUZ3gj6mXEMZdYMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexc_z0WXRrPcQhr2_Ry09gHajryzMGG84ufOuVMPhKfPAMeta } from "/codebuild/output/src3865272267/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete_45qUW_453mRsNJvswMzoushuJcFPyU0CacqIAeS_6D3t4gMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update5_45CIVWkA6E5CyvotHTE7Kp6A7VLg6kPdMdRCnPcjAx0Meta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexcgcfnluqvh0n590yK7E34kvnE2bN2mrE0ADTrSQeI_45oMeta } from "/codebuild/output/src3865272267/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexBm_bq2jmb7vyqsrJ9LLgT27rgPCqmxKjADM4pmdhn2gMeta } from "/codebuild/output/src3865272267/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeKCRmr4KuLqeIjzybH4XrdvBsx4FyPzjPhGZWOduyUd8Meta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexjGrxs5XdgoVggvE5n0SCRtlSE3_MCMxMYxIyBDuvwBsMeta } from "/codebuild/output/src3865272267/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeh3wo5y85MLJlrd1Ckagj07rc7pNcgII8JMTxzFchRK4Meta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index64zG_45GNuveVwYhC0ale30e6tb7PmzzYNTJN5WMD9WTgMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexM0drRmnD2tNle4h5g475MWr8oNFeJSPIeOGx2jfCywgMeta } from "/codebuild/output/src3865272267/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexa4VVymQLpJlrnMkJJakpDuPcD27ViW_sLHGPD_xTnFEMeta } from "/codebuild/output/src3865272267/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateGmWzHzAGHeDbNrqukpTFzS3orqSe6aT6um0OkYbpE4oMeta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmvj8C7lEPA_45OzfoHzWqOL3Z1jJBkOv_v9eNxX5AWoUX4Meta } from "/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuFfU6j7nhJkxeBdE5g4v2IseqrV9Yg82bcqs8QcE7hsQMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexb8OWvbC8sEYyWAwFWlyaEyanwNJeBQDEzx_45ykfG6R7AMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index8rq5MB6Hmv55dn3fRe2swbRYqP_05yqLmtRYG6NOcWMMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3865272267/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index9z0__WRBBLuSa02cNGqEaG6anNyupVHFrAe86R77WtgMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3865272267/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexTagOr1VbE9g7QFZK9nF85qULahG910RvFhsmsS2lcCsMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexZXj3QVbVFocbU28kaIG2MUJb5Ru6UojiGMAvkxjqkXMMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexTXaB5GkFClYV_ZNoc_45_450qATSpJsdR4MO7NdqOFbm_45b8Meta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmlt0eTz_m6gz4aIOoW_tx0qP5pmNfnsNIBjtqWYsXh9AMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmG5meFqNJJBXse9d_458_1cPrrkAh7FLmSc4X34eTsjh_45MMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3865272267/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeq8us3chmiEeO_452KMUuUuLLsmAYGv2hmsxO_1OYUbV_45AMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registereT_45tO2y5BrqasZiKskRYeIZCGFRJgygeLTAJOk7KTyMMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmYqHfBQWTnKwil6xJuW51ep_451CSFhhVuTZYDl615FtXwMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codecYwvJ3DoxxU_45oFYpYDKzNLlakOJZNISWIa4B6PHhytMMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code265RxsrJmWCWDI8Xcwnun29tISxSncaw0V_7A67FOCEMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeBdtWR1DOZ4hrBUPUpdqVVcKp2JqDUrUllLq0mafcDQkMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerdQod6tOReV_4562Efk4_KkERO5N8VOh188QHZD09_OxtkMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmnfZDKWSsEtx0XMJwOLn_45nlo05J2F6KF_451NvGVwt_X5YMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeccBUQ24xsv6XGvoJ8_lfV0TqrC0uIQ7hjH162zqHxzsMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexZ4NQT0ny2x90inrtF39_mfk00Bzk6Q7POl5_45GPgsM64Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete_45bAlMHKPgfi4K7M8ECS2ek0zjK_hlEeR_45FPtpZd1OacMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample_45EOS2qjsATWUzM7Ey4r5QYrEUdnUoQwUNIIVF9pvdtUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email7h0rPBa207UZIfhgAfREwUiCaieyOtzb99WeVZbRQA0Meta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmQH849Us_45FgdtmPdYwyFh4tzQe8gTeUyMVdooUYlcUooMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentjGPPFFFOkul7C21gr942lyd57SW66G_0Pyu8_45JT14hMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmINXsEELaKxAgXGceyZmnIxMWUtK4k4wPnyO0HwZGUEEMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeyqsVY7Wj06XVo4AuPAZduH5I6Pv4fSGUhj5LaAJ5ZlsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code4RAVbeHz_FdcPcwFBYcvU8EH1SGOou38XTOQ2BdSHc0Meta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordnRmmBcPAmz8Oyqx37diGSUwvxs7WhFECq_45HMQ3hH1NEMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register4mtTOtiTYsVtAMMietatPQSqFlY6PWt_TlrozfDem4QMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeBv7ikFRlOtYRB811aZlQASHVAK2r5MeZ6Lvq5rK9TZwMeta || {},
    component: () => import("/codebuild/output/src3865272267/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3865272267/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]